<template>
    <div class="row left-content justify-content-center">
        <div class="col-12">
            <h1>Create transfer</h1>
        </div>
        <div class="col-5">
            <div class="white-block">
                <div class="container">
                    <b-form>
                        <b-form-input
                            v-model="form.amount"
                            type="text"
                            placeholder="Amount ($)"
                            class="mb-2"
                        ></b-form-input>
                        <b-form-select
                            v-model="form.paymentSystem"
                            :options="paymentSystems"
                            class="mb-2"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Payment system</b-form-select-option>
                            </template>
                        </b-form-select>

                        <b-button variant="primary" type="submit" @click.prevent.stop="create()">Create</b-button>
                    </b-form>
                    <div class="invalid-feedback d-block" v-for="error in errors" :key="error">{{ error }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ServerErrors} from "@/mixins/ServerErrors";
import Swal from "sweetalert2";
import {UrlMixin} from "@/views/admin/Wallet/ProjectWallet/UrlMixin";
export default {
    name: "CreateTransfer",
    props: ['id'],
    mixins: [ServerErrors, UrlMixin],
    data() {
        return {
            errors: [],
            form: {
                amount: null,
                paymentSystem: null
            },
            paymentSystems: ["dwolla", "check", "venmo", "cashApp"]
        }
    },
    methods: {
        create() {
            let loader = this.$loading.show();
            this.errors = [];
            window.axios({
                method: 'POST',
                url: this.getUrl('/admin/wallet/project/wallet/' + this.id + '/transfer/create-manual'),
                data: {
                    amount: parseFloat(this.form.amount),
                    payment_system: this.form.paymentSystem
                }
            })
                .then(() => {
                    this.$router.push({ name: 'admin.project_wallet.client.view', params: { page: this.id } });
                })
                .catch(error => {
                    this.errors = this.server_errors;
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.data.title ? error.response.data.title: "Something went wrong."
                    });
                })
                .finally(() => {
                    loader.hide();
                });
        }
    }
}
</script>